var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2394 4.13963C16.754 3.27621 16.2273 3.11739 15.1547 3.057C14.0833 2.9843 11.389 2.9541 9.05483 2.9541C6.71621 2.9541 4.02082 2.9843 2.95049 3.05588C1.88016 3.11739 1.35226 3.27509 0.862396 4.13963C0.362461 5.00193 0.105225 6.48719 0.105225 9.10206C0.105225 9.1043 0.105225 9.10542 0.105225 9.10542C0.105225 9.10765 0.105225 9.10877 0.105225 9.10877V9.11101C0.105225 11.7147 0.362461 13.2111 0.862396 14.0645C1.35226 14.9279 1.87904 15.0845 2.94937 15.1572C4.02082 15.2198 6.71621 15.2567 9.05483 15.2567C11.389 15.2567 14.0833 15.2198 15.1558 15.1583C16.2284 15.0856 16.7552 14.929 17.2406 14.0656C17.745 13.2123 18 11.7158 18 9.11213C18 9.11213 18 9.10877 18 9.10654C18 9.10654 18 9.1043 18 9.10318C18 6.48719 17.745 5.00193 17.2394 4.13963ZM6.81575 12.4607V5.75015L12.4079 9.10542L6.81575 12.4607Z",
    fill: "#39373A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8947,
    height: 17.8947,
    fill: "white",
    transform: "translate(0.105225 0.158203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.16d2b5616d793862e9cc4486df2b80c2.svg";
export { ForwardRef as ReactComponent };